export const shouldRequestLatestSessionOnly = (
  horizonFilter = 'latest'
) => horizonFilter !== 'latest';

export const appendLatestSessionOnlyParam = (
  query,
  horizonFilter = 'latest'
) => {
  if (!shouldRequestLatestSessionOnly(horizonFilter)) {
    return query;
  }

  const separator = query.includes('?') ? '&' : '?';
  return `${query}${separator}latest_session_only=true`;
};

// Build the query string for GET /market/daily-scores/compare/range.
// `models` and `userIds` are arrays; each element becomes a repeated param.
export const buildHorizonCompareQuery = ({
  resource,
  startDate,
  endDate,
  horizonOffset,
  models = [],
  userIds = [],
}) => {
  const params = new URLSearchParams();
  params.set('resource', resource);
  params.set('start_date', startDate);
  params.set('end_date', endDate);
  params.set('horizon_offset', String(horizonOffset));
  models.forEach((m) => params.append('model', m));
  userIds.forEach((u) => params.append('user', u));
  return params.toString();
};
